import React from "react";

const Footer = () => {
    return (
        <footer>
            <div className="top-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 col-sm-6 col-xs-12">
                            <section className="list">
                                <header>
                                    <h4> دسترسی سریع</h4>
                                </header>
                                <ul>
                                    <li>

                                        <a href="https://www.linkedin.com/in/amirmasoudgaravand/">
                                            <i className="zmdi zmdi-linkedin-box"></i>  امیرمسعود گراوند</a>
                                    </li>
                                    <li>
                                        <a href="">قوانین خرید از سایت </a>
                                    </li>
                                    <li>
                                        <a href="">راهنمای خرید از سایت </a>
                                    </li>
                                    <li>
                                        <a href="">همکاری با ماه کورس </a>
                                    </li>
                                    <li>
                                        <a href="">کسب درآمد از ماه کورس </a>
                                    </li>
                                    <li>
                                        <a href="">ماهنامه طراحی وب</a>
                                    </li>
                                </ul>
                            </section>
                        </div>
                        <div className="col-md-3 col-sm-6 col-xs-12">
                            <section className="list">
                                <header>
                                    <h4> دسترسی سریع</h4>
                                </header>
                                <ul>
                                    <li>
                                        <a href="">مشاهده تمامی دوره ها</a>
                                    </li>
                                    <li>
                                        <a href="">قوانین خرید از سایت </a>
                                    </li>
                                    <li>
                                        <a href="">راهنمای خرید از سایت </a>
                                    </li>
                                    <li>
                                        <a href="">همکاری با ماه کورس </a>
                                    </li>
                                    <li>
                                        <a href="">کسب درآمد از ماه کورس </a>
                                    </li>
                                    <li>
                                        <a href="">ماهنامه طراحی وب</a>
                                    </li>
                                </ul>
                            </section>
                        </div>
                        <div className="col-md-3 col-sm-6 col-xs-12">
                            <section className="list">
                                <header>
                                    <h4> دسترسی سریع</h4>
                                </header>
                                <ul>
                                    <li>
                                        <a href="">مشاهده تمامی دوره ها</a>
                                    </li>
                                    <li>
                                        <a href="">قوانین خرید از سایت </a>
                                    </li>
                                    <li>
                                        <a href="">راهنمای خرید از سایت </a>
                                    </li>
                                    <li>
                                        <a href="">همکاری با ماه کورس </a>
                                    </li>
                                    <li>
                                        <a href="">کسب درآمد از ماه کورس </a>
                                    </li>
                                    <li>
                                        <a href="">ماهنامه طراحی وب</a>
                                    </li>
                                </ul>
                            </section>
                        </div>
                        <div className="col-md-3 col-sm-6 col-xs-12">
                            <section className="list">
                                <header>
                                    <h4> دسترسی سریع</h4>
                                </header>
                                <ul>
                                    <li>
                                        <a href="">مشاهده تمامی دوره ها</a>
                                    </li>
                                    <li>
                                        <a href="">قوانین خرید از سایت </a>
                                    </li>
                                    <li>
                                        <a href="">راهنمای خرید از سایت </a>
                                    </li>
                                    <li>
                                        <a href="">همکاری با ماه کورس </a>
                                    </li>
                                    <li>
                                        <a href="">کسب درآمد از ماه کورس </a>
                                    </li>
                                    <li>
                                        <a href="">ماهنامه طراحی وب</a>
                                    </li>
                                </ul>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottom-footer">
                <div className="container">
                    <p>

                        <a href="https://www.linkedin.com/in/amirmasoudgaravand/"> Amir Masoud Garavand </a>
                        Powered By
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
